import { TopicLinks } from '@/model/data-object/TopicLinks'

export class PostTopic {
  id = 0
  extId = ''
  topicName = ''
  links: TopicLinks = new TopicLinks()
}
